import DashboardOrdersRow from '../DashboardOrdersRow'

interface RowRenderProps {
  rows: unknown[] | never[]
}

const DashboardRowRender = ({ rows = [] }: RowRenderProps) =>
  rows.map((row: any) => {
    return <DashboardOrdersRow row={row} key={row.id} />
  })

export default DashboardRowRender
